import type { ListItemTextProps } from '@mui/material';
import MuIListItemText from '@mui/material/ListItemText';
import { forwardRef } from 'react';

const ListItemText = forwardRef<HTMLDivElement, ListItemTextProps>(
  (props, ref) => {
    return <MuIListItemText ref={ref} {...props} />;
  },
);
export default ListItemText;
